import { defineProvider } from '@nuxt/image/runtime'
import { toKonfettiWidth } from '~/utils/mediaHelpers'

/**
 * Max width 910 plus the smaller tiers (only these appear in URLs).
 *
 * 160 serves the kit buy-box thumb: a 48px square box cropped with
 * `object-cover`, so the file has to be wide enough for its *height* to fill the
 * box — the media service only scales to width, it cannot crop to a square.
 * 160x0 lands at 160x90, i.e. 94% of the 96 device px a 48px box needs at 2x.
 *
 * Careful adding rungs: requests snap *up*, so any rung in [163, 360) would
 * capture EventGalleryGrid's mobile case (xs:34vw of a 480px screen = 163px)
 * and pull it down from 360. That is why this stops at 160 rather than the ~171
 * the arithmetic above would otherwise ask for. The unit test pins both.
 */
const WIDTH_RUNGS = [160, 360, 540, 720, 910] as const

function snapToKonfettiWidth(raw: number): number {
  const w = Math.max(1, Math.round(raw))
  for (const rung of WIDTH_RUNGS) {
    if (w <= rung) {
      return rung
    }
  }
  return WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
}

export default defineProvider<{ baseURL?: string }>({
  getImage(src, { modifiers = {}, baseURL = 'https://media.gokonfetti.com/' }) {
    let width = Number(modifiers?.width || 0)
    if (!width || Number.isNaN(width)) {
      width = WIDTH_RUNGS[WIDTH_RUNGS.length - 1]
    }

    width = snapToKonfettiWidth(width)

    const base = baseURL.replace(/\/$/, '')
    return {
      url: toKonfettiWidth(src.trim(), width, base),
    }
  },
})
